/** Configuración regional usada para formatear importes. */
export const PRICE_LOCALE = 'es-ES'

/** Divisa por defecto cuando no se especifica. */
export const DEFAULT_CURRENCY = 'EUR'

/** Prefijo mostrado en las variantes "from" / `showFrom`. */
export const FROM_PREFIX = 'Desde'

/** Contexto para lectores de pantalla en la variante "offer" (texto
 * visualmente oculto): el tachado y el resaltado solo se ven. */
export const ORIGINAL_PRICE_SR_LABEL = 'Precio original'
export const FINAL_PRICE_SR_LABEL = 'Precio final'

/** Decimales fijos en la representación monetaria. */
export const FRACTION_DIGITS = 2

/** Texto mostrado en vez del importe cuando `isFree` es `true` (FR-003). */
export const FREE_LABEL = 'Gratis'
